import React from 'react';
import { Flex, FlexJustify, FlexBehavior } from 'react-magma-dom';

export const ContactUsError = (): JSX.Element => {
  return (
    <Flex behavior={FlexBehavior.container} justify={FlexJustify.center}>
      <div data-testid="error">
        It looks like an error has occurred. Please <a href="https://cengage.com.au/contact-us"> contact us </a> so we
        can help solve this for you.
      </div>
    </Flex>
  );
};
